import { render, staticRenderFns } from "./FAQSection.vue?vue&type=template&id=d8392c6a&scoped=true&"
import script from "./FAQSection.vue?vue&type=script&lang=js&"
export * from "./FAQSection.vue?vue&type=script&lang=js&"
import style0 from "./FAQSection.vue?vue&type=style&index=0&id=d8392c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8392c6a",
  null
  
)

export default component.exports